"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoRecommendationStatuses = void 0;
var algoRecommendationStatuses;
(function (algoRecommendationStatuses) {
    /**
     * The recommendation request is pending to be sent to the algorithm component
     */
    algoRecommendationStatuses["PENDING"] = "pending";
    /**
     * The recommendation request is sent to the algorithm component
     */
    algoRecommendationStatuses["SENT"] = "sent";
    /**
     * The algo recommendation is handled by the algorithm component
     */
    algoRecommendationStatuses["HANDLED"] = "handled";
    /**
     * The algorithm component returned error for the algo recommendation request
     */
    algoRecommendationStatuses["ERROR"] = "error";
    /**
     * The algo recommendation requests is canceled
     */
    algoRecommendationStatuses["CANCELED"] = "canceled";
    /**
     * The algo recommendation request is failed due to internal error
     */
    algoRecommendationStatuses["INTERNAL_ERROR"] = "internalError";
    /**
     * The algorithm component did not provided recommendation on time
     */
    algoRecommendationStatuses["TIMED_OUT"] = "timedOut";
})(algoRecommendationStatuses || (exports.algoRecommendationStatuses = algoRecommendationStatuses = {}));
